import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { 
  addPreconnects, 
  addResourceHints, 
  registerServiceWorker,
  reportWebVitals 
} from "./lib/performanceEnhancements";
import ErrorBoundary from "./components/error/ErrorBoundary";
import { setupGlobalErrorHandling } from "./lib/errorHandling";

// Import touch target validator for development
if (import.meta.env.DEV) {
  import("./utils/touchTargetValidator.js");
}

// Initialize performance optimizations
addPreconnects();
addResourceHints();
registerServiceWorker();

// Setup comprehensive error handling
setupGlobalErrorHandling();

// Monitor Web Vitals in production
if (process.env.NODE_ENV === 'production') {
  import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB }) => {
    onCLS(reportWebVitals);
    onFID(reportWebVitals);
    onFCP(reportWebVitals);
    onLCP(reportWebVitals);
    onTTFB(reportWebVitals);
  });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
